import { configureStore } from '@reduxjs/toolkit';

import { rootReducer } from './reducers';

export function createApplicationStore() {
  return configureStore({
    devTools: { name: 'Admin Next' },
    reducer: rootReducer,
  });
}

export const store = createApplicationStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
